<template>
  <div class="mit-admin-monitor-page mit-page">
      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>Monitor Password Activity</v-card-title>
            <v-card-subtitle class="caption">Check password change activity and status</v-card-subtitle>
            <v-divider></v-divider>
              <MitPasswordActivityList></MitPasswordActivityList>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import MitPasswordActivityList from '../../components/pass/MitPasswordActivityList.vue';

  export default {
    name: 'MitMyKeysPage',
    components: {
      MitPasswordActivityList
    },
    data: function() {
      return {
      }
    },
    mounted() {
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
  .mit-table {
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .mit-my-borrowed-list {
    padding-bottom: 30px;
  }
</style>
